export { default } from './RedirectionHandler';
export type { IPrismicRedirectionHandlerItem } from './types';
